// Public website copy. Deliberately quotes no deal counts (client ask, Oct
// 2026): Individual's active-deal cap is enforced in-app but not advertised, so
// no card here — not even Team's — talks about deals at all.
export const PRICING_PLAN_FEATURES: Record<string, string[]> = {
  solo_monthly: ["1 agent seat + 1 assistant seat", "Client access included — clients, lenders & attorneys collaborate free", "Buyer & seller pathways · calm client view", "Add a seat any time — no tier jump"],
  team_monthly: ["5 agent seats + 1 admin seat", "One shared team workspace", "Client access included — clients, lenders & attorneys collaborate free", "Everything in Individual, plus team roles & audit"],
  growth_monthly: ["10 agent seats + 1 admin seat", "One shared team workspace", "Everything in Team", "Priority support and guided setup"],
  // One offering, one form: Brokerage and Enterprise are both quoted privately,
  // so listing them as two cards only made a visitor pick between identical CTAs.
  custom: ["Multi-team seat pooling with custom seat & deal envelopes", "Consolidated billing and reporting across offices", "White-glove onboarding and a dedicated success partner", "SSO / SAML and bespoke multi-office rollout on request"],
};

export const PRICING_INTEREST_OPTIONS = [
  { value: PlanInterest.BROKERAGE, label: "Brokerage — one office or a few teams" },
  { value: PlanInterest.ENTERPRISE, label: "Enterprise — multiple offices" },
  { value: PlanInterest.OTHER, label: "Not sure yet" },
];

export const DEMO_FORM_ROLE_OPTIONS = [
  { value: DemoFormRole.AGENT, label: "Agent" },
  { value: DemoFormRole.COORDINATOR, label: "Coordinator" },
  { value: DemoFormRole.CLIENT, label: "Client" },
];

export const DEMO_FORM_CONTACT_OPTIONS = [
  { value: ContactMethod.EMAIL, label: "Email" },
  { value: ContactMethod.PHONE, label: "Phone" },
  { value: ContactMethod.TEXT, label: "Text message" },
];

export const DEMO_FORM_PLAN_OPTIONS = [
  { value: DemoPlan.STARTER, label: "Starter" },
  { value: DemoPlan.STUDIO, label: "Studio" },
  { value: DemoPlan.BROKERAGE, label: "Brokerage" },
];

export const DEMO_FORM_DEFAULT_VALUES = {
  fullName: "", email: "", password: "", phone: "", age: "", birthDate: "",
  appointmentTime: "", website: "", role: DemoFormRole.AGENT, contactMethod: ContactMethod.EMAIL,
  plan: DemoPlan.STARTER, bio: "", terms: false, notifications: true,
  disabledExample: "Disabled field",
};

export const DEMO_FORM_POPULATED_VALUES = {
  ...DEMO_FORM_DEFAULT_VALUES,
  fullName: "Morgan Lee", email: "morgan@example.com", password: "demo-password",
  phone: "+1 555 123 4567", age: "34", birthDate: "1992-04-18",
  appointmentTime: "10:30", website: "https://example.com", role: DemoFormRole.COORDINATOR,
  contactMethod: ContactMethod.TEXT, plan: DemoPlan.STUDIO,
  bio: "A populated example for quickly reviewing every form control.", terms: true,
};
import { ContactMethod, DemoFormRole, DemoPlan, PlanInterest } from "@/enum/common.enum";
